export const environment = {
  production: true,
  envName: 'production',
  apiUrl: 'https://api.map.perare.io',
  mapUrl: 'https://map.perare.io',
  wsUrl: 'wss://perare.io/ws/',

  mapboxToken:
    'pk.eyJ1IjoibWFyaWlhbWFyaWlhIiwiYSI6ImNtcG56dHVrcTAwcW8ycnE1cTY3eWlvNTkifQ.BQnZbTIda-m2Y2LMoFpfaw',
  
  // Sentry DSN for perare-prod project (current production DSN)
  sentryDsn: 'https://73b048d01ea8436247111708eac94158@o4507607579426816.ingest.us.sentry.io/4507607594434560',

  metaPixelId: '1348286280513811',
  gtmContainerId: 'GTM-KTLBW9RL',
};
